import React, { useRef } from 'react';
import classes from './CalendarCellActionLabel.module.scss';
import { Void } from '../../../models/basic-objects';

export type CalendarCellActionLabelViewProps = {
  labelText: string;
  clickHandler: Void;
  itemCount?: number | undefined;
};

export const CalendarCellActionLabelView = ({
  labelText,
  clickHandler
}: CalendarCellActionLabelViewProps): JSX.Element => {
  const anchorRef = useRef<HTMLAnchorElement>(null);
  const anchorHeight = anchorRef.current?.clientHeight ?? 0;
  const siblings = anchorRef.current?.parentElement?.children || [];

  // We have a timing issue!!
  let sumHeight = 0;
  // always skip first element since its always the anchor
  for (let i = 1; i < siblings.length; i++) {
    const margins = 4;
    const sibling = siblings[i];
    const sHeight = sibling.clientHeight;

    sumHeight += sHeight + margins;
  }

  const height = !anchorHeight || sumHeight < anchorHeight ? sumHeight : anchorHeight;

  return (
    <a className={classes.ActionWrapper} onClick={clickHandler} ref={anchorRef}>
      <div className={classes.LabelWrapper} style={{ top: height }}>
        <div className={classes.LabelText}>{labelText}</div>
      </div>
    </a>
  );
};
